export default __webpack_public_path__ + "static/Waymark-Story-d79d072953bbf08b05db89929fbce169.pdf";